import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Modal as BootstrapModal, Button as BootstrapButton } from 'react-bootstrap';

import { Modal } from '@/components/common';

interface IAdherenceReasonModal {
  showModal: boolean;
  hideModal: () => void;
  handleSave: (payload: string) => void;
  currentReason: string;
}

const AdherenceReasonModal = ({
  showModal,
  hideModal,
  handleSave,
  currentReason,
}: IAdherenceReasonModal): React.ReactElement => {
  const { t } = useTranslation();
  const [isRequestProcessing, setIsRequestProcessing] = useState<boolean>(false);
  const [reason, setReason] = useState<string>(currentReason);

  const handleClose = () => {
    setIsRequestProcessing(false);
    hideModal();
  };

  const handleSaveReason = () => {
    setIsRequestProcessing(false);
    hideModal();
    handleSave(reason);
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setReason(event.target.value);
  };

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title style={{ color: '#dc3545' }}>
          {t`gigCompliance.complianceTable.modalSaveReason.title`}
        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
        <StyledTextarea
          value={reason}
          onChange={handleChange}
          maxLength={200}
          placeholder={t`gigCompliance.complianceTable.modalSaveReason.placeholder`}
        />
      </BootstrapModal.Body>
      <BootstrapModal.Footer>
        <BootstrapButton variant="secondary" onClick={handleClose}>
          {t`common.btnCancel`}
        </BootstrapButton>
        <BootstrapButton
          variant="primary"
          onClick={handleSaveReason}
          disabled={reason.length === 0 || isRequestProcessing}
        >
          {t`common.btnSave`}
        </BootstrapButton>
      </BootstrapModal.Footer>
    </Modal>
  );
};

export { AdherenceReasonModal };

const StyledTextarea = styled.textarea.attrs({
  className: 'w-100 px-3 border rounded-3',
})`
  width: 100%;
  height: 120px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  resize: none;
  background-color: #f9fafb;
  padding-top: 10px;
  font-size: 12px;
`;
